import UpdateStProjectsForm from "../../forms/st-projects/UpdateStProjectsForm"

export default function StWorkflowSettings({project, mutateStProject, setWorkflowNavigation, setIsPulling}) {
    return (
        <>
        <div className="SECTION ST-WORKFLOW-SETTINGS">
            <UpdateStProjectsForm project={project} mutateStProject={mutateStProject} setWorkflowNavigation={setWorkflowNavigation} setIsPulling={setIsPulling}/>
        </div>
        </>
    )
}